module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM12 24H8v-4h4v4zm0-6H8v-4h4v4zm0-6H8V8h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V8h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V8h4v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/grid-2.js
// module id = 1166
// module chunks = 14